var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrokenLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8002_237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.864 4C2.8392 4 1.85638 4.4071 1.13174 5.13174C0.407099 5.85638 0 6.8392 0 7.864L0 8.136C0 9.1608 0.407099 10.1436 1.13174 10.8683C1.85638 11.5929 2.8392 12 3.864 12H6.192C5.64572 11.5844 5.21813 11.0327 4.952 10.4H4C0.8 10.4 0.8 5.6 4 5.6H6.4C6.46027 5.60107 6.52027 5.60427 6.58 5.6096L4.972 4H3.864ZM9.808 4C10.3543 4.41557 10.7819 4.9673 11.048 5.6H12C14.5432 5.6024 15.336 9.04 13.0512 10.156L14.2576 11.3624C14.7925 11.011 15.2318 10.5322 15.5359 9.96905C15.84 9.4059 15.9995 8.77602 16 8.136V7.864C16 7.35657 15.9001 6.85411 15.7059 6.38531C15.5117 5.91651 15.2271 5.49055 14.8683 5.13174C14.5095 4.77293 14.0835 4.48831 13.6147 4.29413C13.1459 4.09995 12.6434 4 12.136 4H9.808ZM6.9184 4.024L10.3816 7.4856C10.293 6.59739 9.89963 5.76724 9.26831 5.13621C8.63698 4.50517 7.80665 4.11218 6.9184 4.024ZM5.7816 6.7288C5.736 6.876 5.664 7.2 5.664 7.2C5.628 7.4184 5.6 7.6672 5.6 7.864V8.136C5.6 9.1608 6.0071 10.1436 6.73174 10.8683C7.45638 11.5929 8.4392 12 9.464 12H12.136C12.3893 12 12.6403 11.9749 12.8888 11.9248L11.364 10.4H9.6C7.9464 10.3952 6.792 8.7592 7.344 7.2L5.7816 6.7288ZM8.7856 7.8168C8.81132 8.14998 8.76718 8.48486 8.656 8.8H9.7672L8.7856 7.8168Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.976 0L0 0.976L15.04 16L16 15.024L0.976 0Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8002_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLink);
export default __webpack_public_path__ + "static/media/broken-link.b1a5d216.svg";
export { ForwardRef as ReactComponent };